import "./globalStyles.css";
import { Themes } from "@/typings/theme";

import defaultTheme from "./defaultTheme";

const themes: Themes = {
  default: defaultTheme,
};

export default themes;
